var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-manager-info-component drop-backdrop"},[(_vm.hasManager && _vm.$auth.isAuthenticated)?_c('one-manager-info',{attrs:{"full-name":_vm.manager.name,"phone":_vm.manager.mobilePhone,"email":_vm.manager.email}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }